export default {
  'profilecredit.profilecreditreport': 'Fatturato del conto di credito',
  'profilecredit.creditstatus': 'Stato del Credito',
  'profilecredit.credittotalamount': 'Importo totale del credito assegnato',
  'profilecredit.creditremainamount': 'Importo totale del credito residuo',
  'profilecredit.profilecreditreport': 'Rapporto di credito assegnato',
  'profilecredit.creditamount': 'Ammontare del credito',
  'profilecredit.remaincreditamount': 'Importo residuo del credito',
  'profilecredit.assigndate': 'Data assegnata',
  'profilecredit.duration': 'Durata (giorno)',
  'profilecredit.active': 'Attiva',
  'profilecredit.expired': 'scaduta',
  'profilecredit.sum': 'Somma',
  'profilecredit.expensesamount': 'ُImporto del credito speso',
  'profilecredit.nocredit': 'Niente credito',
  'profilecredit.assigncredit': 'Assegna credito',
  'profilecredit.creditamountceiling': "Massimale dell'importo del credito",
  'profilecredit.deletecredit': 'Elimina credito',
  'profilecredit.deleteconfirmation': 'Sei sicuro di eliminare questo credito?',
  'profilecredit.fullname': 'Nome e cognome',
  'profilecredit.expensesreport': 'Report spese',
  'profilecredit.credit': 'credito',
  'profilecredit.mycreditmanagement': 'La mia gestione dei crediti',
  'profilecredit.creditmanagement': 'Gestione Crediti',
  'profilecredit.employeecreditmanagement':
    'Gestione dei crediti dei dipendenti',
  'profilecredit.creditadd': 'Credito aggiunto con successo',
  'profilecredit.creditadderror':
    "Esiste già un'allocazione attiva per questo profilo",
  'profilecredit.noteligibleprofile':
    "Questo profilo non è idoneo per un'allocazione",
  'profilecredit.downloadexcel': 'Scarica file Excel',
  'profilecredit.fromdate': 'Dalla data assegnata',
  'profilecredit.todate': 'Alla data assegnata',
};
